import { EnvironmentBanner, ImpersonationBanner } from '@korint/folio';
import { Outlet } from 'react-router-dom';
import { Stack } from '@folio/components/ui/flex';

export function CustomFunnelLayout({
  customLayout,
}: {
  customLayout: { header?: string; footer?: string } | undefined;
}) {
  const { header, footer } = customLayout ?? {};

  return (
    <Stack gap={0} className="min-h-screen">
      {header && <div dangerouslySetInnerHTML={{ __html: header }} />}
      <ImpersonationBanner />
      <EnvironmentBanner />
      <div className="flex-1 py-12">
        <Outlet />
      </div>
      {footer && <div dangerouslySetInnerHTML={{ __html: footer }} />}
    </Stack>
  );
}
